import { Loader } from '@googlemaps/js-api-loader';
import { environment } from 'src/environments/environment';
import { languageRegionMap } from '../shared/constants/languageRegions.constants';

let loaderInstance: Loader | null = null;

export function getGoogleMapsLoader(currentLang: string = 'en'): Loader {
  if (loaderInstance) {
    return loaderInstance;
  }

  const { language, region } =
    languageRegionMap[currentLang] || { language: 'en', region: 'US' };

  loaderInstance = new Loader({
    apiKey: environment.googleMapsKey,
    version: 'weekly',
    language,
    region
  });

  return loaderInstance;
}
